'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$CreateUP(username, password) {
  this.Z1 = null;
  this.Z0 = null;
  this.Z1 = username;
  this.Z0 = password;
}
export { $c_Lpresto_types$proto$CreateUP as $c_Lpresto_types$proto$CreateUP };
$p = $c_Lpresto_types$proto$CreateUP.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$CreateUP;
/** @constructor */
function $h_Lpresto_types$proto$CreateUP() {
}
export { $h_Lpresto_types$proto$CreateUP as $h_Lpresto_types$proto$CreateUP };
$h_Lpresto_types$proto$CreateUP.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$proto$CreateUP) && ((this.Z1 === x$0.Z1) && (this.Z0 === x$0.Z0))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "CreateUP";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Z1;
  }
  if ((n === 1)) {
    return this.Z0;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$CreateUP(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kR)));
}
export { $isArrayOf_Lpresto_types$proto$CreateUP as $isArrayOf_Lpresto_types$proto$CreateUP };
var $d_Lpresto_types$proto$CreateUP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$CreateUP, "presto.types$proto$CreateUP", ({
  kR: 1,
  bx: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$CreateUP as $d_Lpresto_types$proto$CreateUP };
//# sourceMappingURL=presto.types$proto$-Create-U-P.js.map
